import {
  postQuestion,
  updateQuestion,
} from "../../../utils/API/questionMethods";
import { styled } from "@mui/material/styles";

import { Formik } from "formik";
import { Button, Box } from "@mui/material";
import CustomField from "../../shared/CustomTextField";
import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { deleteAnswer } from "../../../utils/API/answerMethods";
import AnswerForm from "./AnswerForm";
import EditIcon from "@mui/icons-material/Edit";
import ThemeSmallGrid from "./ThemeSmallGrid";
import { deleteThemeToQuestion } from "../../../utils/API/themeMethods";
import VideoUploader from "../../VideoUploader";
import { uploaderType } from "../../../utils/config";
import { questionValidation } from "../../../utils/validation";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function QuestionForm() {
  const store = useStore();
  const questionData = store.form.dataToUpdate;

  const initValues = questionData || {
    id: "",
    text: "",
    description: "",
    error_text: "",
    image_src: "",
  };

  const submitQuestion = (values) => {
    postQuestion(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const submiQuestionUpdated = (values) => {
    updateQuestion(values, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const openAnswerForm = () => {
    store.setChildModal(<AnswerForm />);
  };

  const openThemeModal = () => {
    store.setChildModal(<ThemeSmallGrid />);
  };

  const openAnsweRedact = (data) => {
    store.setChildModal(<AnswerForm />, null, data);
  };

  const handleDeleteAnswer = (id) => {
    const questionAnswer = store.form.dataToUpdate.answers;

    deleteAnswer(id).then(({ data, status }) => {
      if (status === 200) {
        const newQuestionList = questionAnswer.filter((item) => item.id !== id);
        store.setForm(store.form.formChildren, store.form.callBack, {
          ...questionData,
          answers: newQuestionList,
        });
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const handleDeleteTheme = (themeId) => {
    const questionTheme = store.form.dataToUpdate.themes;
    deleteThemeToQuestion(themeId).then(({ data, status }) => {
      if (status === 200) {
        const newThemeList = questionTheme.filter(
          (item) => item.id !== themeId
        );
        store.setForm(store.form.formChildren, store.form.callBack, {
          ...questionData,
          answers: questionData.answers,
          themes: newThemeList,
        });
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = { flexDirection: "row" };
  const formWidth = questionData ? "950px" : "600px";
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (questionData) {
          submiQuestionUpdated(values);
        } else {
          submitQuestion(values);
        }

        setSubmitting(false);
      }}
      validationSchema={questionValidation}>
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        errors,
      }) => (
        <>
          <p>{questionData ? "Изменение вопроса" : "Создание вопроса"}</p>
          <form onSubmit={handleSubmit} style={{ width: formWidth }}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <VideoUploader
                  error={errors.image_src}
                  helperText={errors.image_src}
                  endpoint={"image/test"}
                  type={uploaderType.image}
                  label={"Изображение к вопросу"}
                  onChange={(fileData) => {
                    values.image_src = fileData.finalFilename;
                  }}
                  previewStyle={{
                    width: "80%",
                    height: "auto",
                    aspectRatio: "16/9",
                  }}
                  defaultSrc={values.image_src}
                />

                <CustomField
                  name="text"
                  label="Текст вопроса"
                  multiline
                  rows={3}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.text}
                  error={errors.text}
                  helperText={errors.text}
                />
                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label={"Комментарий к вопросу"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
                <CustomField
                  multiline
                  rows={3}
                  name="error_text"
                  label={"Пояснение"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={errors.error_text}
                  value={values.error_text}
                  error={errors.error_text}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}>
                {questionData && (
                  <Box
                    className={Styles.question_list}
                    sx={{ height: "200px" }}>
                    <p style={{}}>
                      Список ответов{" "}
                      <AddIcon fontSize="small" onClick={openAnswerForm} />
                    </p>
                    <div className={Styles.question_grid}>
                      {questionData.answers.map((item) => (
                        <div
                          key={item.id}
                          className={
                            Styles.question_grid_elem + " " + Styles.answer_elem
                          }>
                          <span className={Styles.grid_text}>{item.text}</span>

                          <span>{!!item.is_true && "Верный ответ"}</span>
                          <EditIcon
                            fontSize="small"
                            onClick={() => openAnsweRedact(item)}
                          />
                          <DeleteIcon
                            onClick={() => handleDeleteAnswer(item.id)}
                            fontSize="small"
                            className={Styles.delete_question}
                          />
                        </div>
                      ))}
                    </div>
                  </Box>
                )}

                {questionData && (
                  <Box
                    className={Styles.question_list}
                    sx={{ height: "150px" }}>
                    <p>
                      Темы вопроса
                      <AddIcon fontSize="small" onClick={openThemeModal} />
                    </p>
                    <div className={Styles.question_grid}>
                      {questionData.themes.map((item) => (
                        <div
                          key={item.id}
                          className={Styles.question_grid_elem}>
                          <span>{item.theme_name}</span>

                          <span>{!!item.is_true && "Верный ответ"}</span>
                          <DeleteIcon
                            onClick={() => handleDeleteTheme(item.id)}
                            fontSize="small"
                            className={Styles.delete_question}
                          />
                        </div>
                      ))}
                    </div>
                  </Box>
                )}
              </div>
            </div>
            <div className="form_actions">
              <Button onClick={handleReset} disabled={questionData}>
                Очистить
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
